import React from 'react';
import { UserX, Plug, Droplets, Users, TrendingUp, Award, CheckCircle } from 'lucide-react';
import { implementationSection } from '../mock';

const iconMap = {
  UserX: UserX,
  Plug: Plug,
  Droplets: Droplets,
  Users: Users,
  TrendingUp: TrendingUp,
  Award: Award
};

export const Implementation = () => {
  return (
    <section id="implementation" style={{
      background: '#3A4149',
      padding: '8rem 1.5rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Subtle Mountain Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.08
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '5rem', maxWidth: '900px', margin: '0 auto 5rem' }}>
          <h2 style={{ 
            fontFamily: "'Playfair Display', Georgia, serif",
            marginBottom: '1.5rem', 
            color: '#FFFFFF',
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            fontStyle: 'italic'
          }}>
            {implementationSection.heading}
          </h2>
          
          <h3 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
            color: '#7EC0D6',
            fontWeight: 600,
            fontStyle: 'italic'
          }}>
            {implementationSection.subheading}
          </h3>
        </div>

        {/* Benefits Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '2rem',
          marginBottom: '5rem'
        }} className="implementation-grid">
          {implementationSection.benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div key={index} className="feature-card hover-lift" style={{
                background: 'rgba(67, 75, 84, 0.8)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '1rem',
                  background: 'rgba(0, 191, 255, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.5rem'
                }}>
                  <IconComponent size={36} color="#00BFFF" />
                </div>
                <h4 style={{ fontFamily: "'Open Sans', sans-serif", marginBottom: '1rem', color: '#FFFFFF', fontWeight: 600, fontSize: '1.25rem' }}>
                  {benefit.title}
                </h4>
                <p style={{ fontFamily: "'Open Sans', sans-serif", lineHeight: '1.7', color: '#E0E0E0', fontSize: '0.95rem' }}>
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Services */}
        <div className="feature-card" style={{
          background: 'rgba(92, 112, 128, 0.4)',
          padding: '3rem',
          textAlign: 'center',
          border: '1px solid rgba(0, 191, 255, 0.3)'
        }}>
          <h3 style={{ fontFamily: "'Playfair Display', Georgia, serif", marginBottom: '2.5rem', color: '#7EC0D6', fontSize: '1.75rem', fontStyle: 'italic' }}>
            {implementationSection.additionalServices.heading}
          </h3>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.5rem'
          }}>
            {implementationSection.additionalServices.services.map((service, index) => (
              <div key={index} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                background: 'rgba(44, 52, 64, 0.8)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                textAlign: 'left',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <CheckCircle size={24} color="#00BFFF" style={{ flexShrink: 0 }} />
                <span style={{ fontFamily: "'Open Sans', sans-serif", fontWeight: 500, color: '#E0E0E0' }}>{service}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Add styles for responsive behavior
const styles = `
  @media (max-width: 1024px) {
    .implementation-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
  @media (max-width: 640px) {
    .implementation-grid {
      grid-template-columns: 1fr !important;
    }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleTag = document.createElement('style');
  styleTag.textContent = styles;
  document.head.appendChild(styleTag);
}
